import PresentacionBuscador from "../components/PresentacionBuscador";
import Categorias from "../components/Categorias";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PublicidadTarjeta from "../components/PublicidadTarjeta";

function IndexPage() {
  return (
    <div className="IndexPage">
      <Header/>
      <PresentacionBuscador />
      <Categorias/>
      <PublicidadTarjeta/>
      <Footer/>
    </div>
  );
}

export default IndexPage;
